var map = {
	"./CarouselBook": 2962,
	"./CarouselBook.css": 1530,
	"./CarouselBook.js": 2962,
	"./assets/Held.jpeg": 709,
	"./assets/aColdSpell.jpeg": 8998,
	"./assets/book-banner.jpg": 411,
	"./assets/book-banner111.jpg": 6740,
	"./assets/book-banner22.jpg": 136,
	"./assets/book-banner33.jpg": 6383,
	"./assets/gioiThieu.webp": 4239,
	"./assets/intro.jpg": 8570,
	"./assets/intro2.jpg": 8290,
	"./assets/mission.jpg": 1760,
	"./assets/mission.webp": 8675,
	"./assets/theRestIsHistory.jpeg": 9009,
	"./assets/theRestIsHistory2.jpeg": 8355,
	"./assets/theTempleOfFortuna.jpeg": 8947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3006;